module.exports = __webpack_public_path__ + "img/DE06159.5af4dd5d.png";